import React from 'react';
import { toast } from 'sonner';
import { Bell, X } from 'lucide-react';

/**
 * Custom Toast component matching the requested design
 */
const CustomToastUI = ({ message, type, t }) => {
    const getIconColor = () => {
        switch (type) {
            case 'success': return 'text-green-500';
            case 'error': return 'text-red-500';
            case 'warning': return 'text-amber-500';
            case 'info': return 'text-blue-500';
            default: return 'text-[#D0021B]';
        }
    };

    return (
        <div className="bg-white rounded-lg shadow-xl border border-gray-100 overflow-hidden w-[350px] animate-in fade-in slide-in-from-right-full duration-300">
            {/* Header */}
            <div className="px-4 py-2 flex items-center justify-between bg-white border-b border-gray-100">
                <div className="flex items-center gap-2">
                    <Bell className={`w-4 h-4 ${getIconColor()}`} />
                    <span className="font-semibold text-sm text-[#1A1A1A]">Press ID System</span>
                </div>
                <div className="flex items-center gap-3">
                    <span className="text-[11px] text-gray-400">Just now</span>
                    <button 
                        onClick={() => toast.dismiss(t)}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <X className="w-4 h-4" />
                    </button>
                </div>
            </div>
            
            {/* Body */}
            <div className="px-4 py-3 bg-white">
                <p className="text-sm text-gray-600 leading-relaxed font-normal">
                    {message}
                </p>
            </div>
        </div>
    );
};

export const toastUtils = {
    success: (message) => {
        toast.custom((t) => (
            <CustomToastUI message={message} type="success" t={t} />
        ));
    },
    error: (message) => {
        toast.custom((t) => (
            <CustomToastUI message={message} type="error" t={t} />
        ));
    },
    info: (message) => {
        toast.custom((t) => (
            <CustomToastUI message={message} type="info" t={t} />
        ));
    },
    warning: (message) => {
        toast.custom((t) => (
            <CustomToastUI message={message} type="warning" t={t} />
        ));
    }
};

export default toastUtils;
